/* eslint-disable max-len */
/* global google */

import { getSvgDataURI } from 'utils';

function initLocationMap() {
    const mapContainer = document.getElementById('js-location-map');

    if (
        !mapContainer ||
        !window.config ||
        !window.config.locationMapSettings ||
        !window.config.locationMapSettings.center
    ) {
        return;
    }

    const { center, zoom } = window.config.locationMapSettings;

    const icon = {
        url: getSvgDataURI(
            `<svg
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               width="40"
               height="40"
               viewBox="0 0 24 24">
            <defs>
              <path id="a"
              d="M1,0 L18.0568107,0 C18.6090954,-1.47001255e-15 19.0568107,0.44771525 19.0568107,1 C19.0568107,1.20842298 18.9916875,1.41163744 18.8705441,1.58123819 L15.4487723,6.37171879 C15.1844055,6.74183232 15.2031069,7.24372833 15.4942845,7.59314138 L18.6331797,11.3598156 C18.9867437,11.7840925 18.9294197,12.4146572 18.5051428,12.7682213 C18.3254278,12.9179838 18.0988949,13 17.8649584,13 L1,13 C0.44771525,13 6.76353751e-17,12.5522847 0,12 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <path d="M0 0 24 0 24 24 0 24z"/>
              <path fill="#0E2041" d="M2 14H4V21H2z"/>
              <g transform="translate(2 3)">
                <mask id="b" fill="#fff">
                  <use xlink:href="#a"/>
                </mask>
                <use xlink:href="#a" fill="#1B3668"/>
                <path
                 fill="#FFF"
                 fill-rule="nonzero"
                 d="M12.0470883,9.83062809 L9.62425719,9.83062809 C9.62425719,9.83062809 9.89278255,8.7748765 9.89278255,8.76923077 C9.02617798,9.60479887 8.34265888,10 7.07326626,10 C4.65653801,10 3.58853942,7.97882851 4.14389869,5.85603387 C4.7297722,3.57515879 6.48739275,2 9.03228082,2 C10.0575595,2 11.088941,2.46859562 11.3452606,3.03316867 L11.5710661,2.12420607 L14,2.12420607 L12.0470883,9.83062809 Z M9.1787492,3.6146789 C8.05582497,3.6146789 6.99392922,4.54057869 6.62775828,5.98588567 C6.26769018,7.43119266 6.84135799,8.33450953 7.96428223,8.33450953 C9.08720647,8.33450953 10.1246908,7.43119266 10.4847589,5.98588567 C10.8570327,4.54057869 10.277262,3.6146789 9.1787492,3.6146789 Z" mask="url(#b)"/>
                <path fill="#953F91" d="M0 12 2 12 2 13 0 13z" mask="url(#b)"/>
                <path fill="#C8318A" d="M2 12 5 12 5 13 2 13z" mask="url(#b)"/>
                <path fill="#E94D18" d="M5 12 9 12 9 13 5 13z" mask="url(#b)"/>
                <path fill="#94C23D" d="M9 12 20 12 20 13 9 13z" mask="url(#b)"/>
              </g>
            </g>
          </svg>`
        ),
        size: new google.maps.Size(40, 40)
    };

    const map = new google.maps.Map(mapContainer, {
        zoom,
        center
    });

    new google.maps.Marker({
        position: center,
        icon,
        map
    });
}

initLocationMap();
